import React from "react";
import { EmptyState } from "./EmptyState";
import { useNavigate } from "react-router";
import Home from "../Home/Home";
import { Header } from "../common/Header";
import { updateQueryParams } from "../../utils/commanFunctions";
import { translations } from "../../contentConfig";
import ImageComponent from "../Trip/ImageComponent";
import headerImage from "../../commonImages/personalizeYourStay.jpg"
import { trackPersonalizedFlow } from "../../utils/FunctionsForGa";
import configs from "../../contentConfig";

const initPageConfig = configs?.explore?.personaliseYourStay?.initPage || {};
const showInitImage = initPageConfig.showImage ?? true;
const eyebrowText = initPageConfig.eyebrow || "";
const titleText =
  initPageConfig.title ||
  translations?.personalizedStayTitle ||
  "Perks, Picks, & Hidden Gems Await";
const descText =
  initPageConfig.description ||
  translations?.personalizedStayDesc ||
  "Discover the best local events, attractions, and hidden gems tailored just for you. Answer a few quick questions so we can personalize your Las Vegas adventure.";

const PersonalizedStayInit = ({ setInIt }) => {
  const navigate = useNavigate();
  const onContinue = (e) => {
    e.stopPropagation();

    trackPersonalizedFlow({
    action: "start"
  });
    const path = updateQueryParams({
      path: "personalizedStayModal",
    });
    navigate(path);
  };
  return (
    <Home
      nav={"List"}
      showBottomNav={false}
      showPersonalizedButton={false}
      showOldFilter={false}
    >
      <Header
        data={{
          title: "PERSONALIZED STAY",
          // goBackToParent:window.GoBackToParent
          // eventType:"INNSPIRE_GO_HOME",
          // eventData:{}
        }}
        showFilter={false}
        showSearch={false}
        showBookMark={false}
        showBack={true}
        intialFetch={false}
      />
      <div className="pers-init-ui-container flex flex-col w-full h-[calc(100vh-40px)] items-start gap-10 pt-[124px] pb-32 px-0 relative bg-white rounded-[48px] overflow-hidden ">
        <div className="pers-init-ui-sec-container flex flex-col items-center justify-center gap-12 px-4 py-0 relative flex-1 self-stretch w-full grow ">
          {/* <EmptyState className="!flex-[0_0_auto] pers-ui-stay-block" /> */}
          {showInitImage && <ImageComponent imageUrl={headerImage} passedClasses={"max-h-[50%]"}/>}
          <div className=" pers-ui-text-and-button ">
          <div className="flex flex-col items-center justify-center gap-6 relative self-stretch w-full flex-[0_0_auto] per-stay-description-padding">
            <div className="pers-init-ui-text-content flex flex-col items-start gap-2 relative self-stretch w-full flex-[0_0_auto]">
              {eyebrowText && (
                <p className="per-stay-eyebrow">{eyebrowText}</p>
              )}
              <div className=" relative self-stretch mt-[-1.00px] font-normal text-wwwstanfordcourtcomblack text-2xl text-center tracking-[0] leading-8 per-stay-button ">
                {titleText}
              </div>

              <p className="relative w-full font-secondary font-normal text-[#888888] text-base text-center tracking-[0] leading-4 per-stay-description">
                {descText}
              </p>
            </div>
          </div>

          <button
            onClick={onContinue}
            className="pers-init-ui-button all-[unset] box-border flex h-12 items-center justify-center gap-1 px-6 py-0 relative self-stretch w-full bg-black  bottom-btn"
          >
            <button className="pers-init-ui-button all-[unset] box-border relative w-fit font-normal text-white text-lg tracking-[0] leading-[20.7px] whitespace-nowrap">
              Continue
            </button>
          </button>
          </div>
        </div>

        {/* <div className="flex flex-col w-[393px] items-center pt-0 pb-2 px-0 fixed top-0 left-0 bg-white">
          <div className="flex w-[393px] h-[59px] items-end justify-center relative">
            <div className="flex-col justify-center gap-2 pl-2.5 pr-0 pt-0 pb-[3px] self-stretch flex items-center relative flex-1 grow">
              <StatusbarTime
                darkMode={false}
                time="9:41"
                timeClassName="!tracking-[-0.32px] !text-base ![font-style:unset] !font-bold ![font-family:'Akkurat-Bold',Helvetica] !leading-[21px]"
                type="default"
              />
            </div>
  
            <div className="relative self-stretch flex-[0_0_auto]" />
  
            <div className="flex items-center justify-center gap-2 pl-0 pr-[11px] py-0 self-stretch relative flex-1 grow">
              <div className="inline-flex items-start gap-2 relative flex-[0_0_auto]">
                <img
                  className="relative w-[18px] h-3"
                  alt="Icon mobile signal"
                  src="https://c.animaapp.com/BINDtKPF/img/icon---mobile-signal-2.svg"
                />
  
                <img
                  className="relative w-[17px] h-[11.83px]"
                  alt="Wifi"
                  src="https://c.animaapp.com/BINDtKPF/img/wifi-2.svg"
                />
  
                <StatusbarBattery
                  className="!relative !w-[27.4px] !h-[13px]"
                  color="#010202"
                />
              </div>
            </div>
          </div>
  
          <div className="flex h-[33px] justify-center px-3 py-0 self-stretch w-full items-center relative">
            <div className="gap-1 mt-[-3.50px] mb-[-3.50px] flex items-center relative flex-1 grow">
              <div className="inline-flex gap-2 p-2 flex-[0_0_auto] items-center relative">
                <img
                  className="relative flex-[0_0_auto]"
                  alt="Chevron"
                  src="https://c.animaapp.com/BINDtKPF/img/chevron.svg"
                />
  
                <div className="relative w-fit [font-family:'Akkurat-Regular',Helvetica] font-normal text-wwwstanfordcourtcomblack text-base tracking-[0] leading-[normal] whitespace-nowrap">
                  Back
                </div>
              </div>
            </div>
  
            <img
              className="relative flex-[0_0_auto]"
              alt="Middle"
              src="https://c.animaapp.com/BINDtKPF/img/middle.svg"
            />
  
            <div className="relative flex-1 grow" />
          </div>
        </div> */}
      </div>
    </Home>
  );
};

export default PersonalizedStayInit;
